/* eslint-disable */
export const START_LOAD_CALENDAR = 'START_LOAD_CALENDAR';
export const FINISH_LOAD_CALENDAR = 'FINISH_LOAD_CALENDAR';
export const ERROR_LOAD_CALENDAR = 'ERROR_LOAD_CALENDAR';

export const START_LOAD_CHAMPIONATS = 'START_LOAD_CHAMPIONATS';
export const FINISH_LOAD_CHAMPIONATS = 'FINISH_LOAD_CHAMPIONATS';
export const ERROR_LOAD_CHAMPIONATS = 'ERROR_LOAD_CHAMPIONATS';

export const START_LOAD_LIVES = 'START_LOAD_LIVES';
export const FINISH_LOAD_LIVES = 'FINISH_LOAD_LIVES';
export const ERROR_LOAD_LIVES = 'ERROR_LOAD_LIVES';



// WEBPACK FOOTER //
// ./src/models/calendar/constants.js